

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const products = document.querySelectorAll(".template-collection .boost-sd__product-list .boost-sd__product-item, .template-product .cstm-prdct-cls");

    products.forEach((product) => {
      const price = product.querySelector(".boost-sd__product-price--sale .boost-sd__format-currency, .price .current-price");
      const comparePrice = product.querySelector(".boost-sd__product-price--compare .boost-sd__format-currency, .price .was-price");

      if (comparePrice && comparePrice.textContent.trim() !== "") {
        product.classList.add("sale");
        product.classList.remove("no-sale");
      } else {
        product.classList.add("no-sale");
        product.classList.remove("sale");
      }
    });
  }, 8000);
});



document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const products = document.querySelectorAll(".boost-sd__product-item");

    products.forEach(function(product) {
      const title = product.querySelector(".boost-sd__product-title");
      if (title && title.textContent.toLowerCase().includes("ultra")) {
        product.classList.add("ultra");
      }
    });
  }, 5000);
});





document.addEventListener("DOMContentLoaded", function () {
    const currentUrl = window.location.href;

    const menuItems = {
        "https://coldest.com/collections/core-colors": ".cstm-hdr-mnu-sec .mnu-itm.core-collection",
        "https://coldest.com/collections/limitless-bottle-with-handle": ".cstm-hdr-mnu-sec .mnu-itm.drop-homcol",
        "https://coldest.com/collections/limitless-deals-and-steals": ".cstm-hdr-mnu-sec .mnu-itm.sale-collection",
        "https://coldest.com/pages/drop": ".cstm-hdr-mnu-sec .mnu-itm.drops-home",
        "https://coldest.com/pages/sale": ".cstm-hdr-mnu-sec .mnu-itm.sale-home"
    };

    const additionalPages = [
        "https://coldest.com/collections/for-her",
        "https://coldest.com/collections/for-him"
    ];

  
    Object.keys(menuItems).forEach(url => {
        if (currentUrl.includes(url)) {
            const menuItem = document.querySelector(menuItems[url]);
            if (menuItem) {
                menuItem.classList.add("mnu-actv");
            }
        }
    });

    

    additionalPages.forEach(url => {
        if (currentUrl.includes(url)) {
            document.querySelector(".cstm-hdr-mnu-sec").style.display = "block";
        }
    });

});









window.addEventListener("load", (event) => {

  
// Blackhawk Camo
  document.querySelector('.product-list .product-block[data-variant-id="46924712575208"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46924712575208"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
// Rocketship Alloy
  document.querySelector('.product-list .product-block[data-variant-id="46875870494952"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Low Inventory';
  document.querySelector('.product-list .product-block[data-variant-id="46875870494952"] .samita_productLabel-content[data-id="52332"]').id = 'LI';
// Blue Nova
  document.querySelector('.product-list .product-block[data-variant-id="46879904661736"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Low Inventory';
  document.querySelector('.product-list .product-block[data-variant-id="46879904661736"] .samita_productLabel-content[data-id="52332"]').id = 'LI';
// Crowned Luna
  document.querySelector('.product-list .product-block[data-variant-id="46875865940200"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46875865940200"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
// Red Nova
  document.querySelector('.product-list .product-block[data-variant-id="46879904596200"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Low Inventory';
  document.querySelector('.product-list .product-block[data-variant-id="46879904596200"] .samita_productLabel-content[data-id="52332"]').id = 'LI';
// Moonlight Hearts
  document.querySelector('.product-list .product-block[data-variant-id="46924713361640"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46924713361640"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
// The Republican
  document.querySelector('.product-list .product-block[data-variant-id="46924713623784"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46924713623784"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
// The Democrat
  document.querySelector('.product-list .product-block[data-variant-id="46924713558248"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46924713558248"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
// The Cardinal
  document.querySelector('.product-list .product-block[data-variant-id="46924713033960"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46924713033960"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
// Avocado Reflections
  document.querySelector('.product-list .product-block[data-variant-id="46924713165032"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46924713165032"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
  
  
  
});


document.addEventListener("DOMContentLoaded", function () {


  const lgnfrm = document.querySelector(".template-customers-login .small-form .opposing-items");                        
  const crtacc = document.createElement('span');
  crtacc.innerText = `Don't have an account?`;
  lgnfrm.appendChild(crtacc);



  
    setTimeout(() => {

const currentUrl = window.location.href;
    const targetUrl = "https://coldest.com/products/coldest-limitless-bottle?variant=46875866136808";

    if (currentUrl === targetUrl) {
        const productOption1 = document.querySelector(".gpo-container");
        if (productOption1) {
            productOption1.classList.add("active");
        }
    }


      
        const swatchItems = document.querySelectorAll("#swatch-option1 .swatch-view-item");
        swatchItems.forEach(item => {
            item.addEventListener("click", function () {
                const productOption = document.querySelector(".gpo-container");
                if (productOption) {
                    if (this.getAttribute("orig-value") === "Red Dress+") {
                        productOption.classList.add("active");
                    } else {
                        productOption.classList.remove("active");
                    }
                }
            });
        });
    }, 5000);
});





